import { ChevronLeftIcon } from '~components/icons'
import { TextButton } from '~components/web-components'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useHasEntityRole } from '~hooks/permissions/use-has-scope'
import { useConstructLinkWithPool } from '../hooks/use-construct-link-with-pool'
import { useShowLimitedExperience } from './navigation-and-footer/navigation/left-navigation/hooks/use-show-limited-experience'

interface Props {
  className?: string
  forceHome?: boolean
}

export function GoBackButton({ className, forceHome = false }: Props) {
  const navigate = useNavigate()
  const isTechnicalManager = useHasEntityRole('vessel', 'technical')
  const dashboardLink = useConstructLinkWithPool('/dashboard/:pool')
  const isDppLimited = useShowLimitedExperience()

  const link = isTechnicalManager ? '/financials' : dashboardLink
  const label = isDppLimited
    ? ''
    : !forceHome
      ? ''
      : isTechnicalManager
        ? 'to Financials'
        : 'to Dashboard'

  return (
    <Box
      sx={{
        margin: 0,
        padding: 0,
      }}
      component={TextButton}
      startIcon={<ChevronLeftIcon fontSize={20} />}
      onClick={() =>
        isDppLimited ? navigate(-1) : forceHome ? navigate(link) : navigate(-1)
      }
      className={className}
    >
      Go Back {label}
    </Box>
  )
}
